import { createUseStyles } from 'react-jss';


import colors from "../../../utils/colors";

var styles = {
  toolDropdown: {
    width: '100%',
    height: '6.4rem',
    marginLeft: '4rem',
    display: 'flex',
    alignItems: 'center'
  },
  dropdownButton: function dropdownButton(_ref) {var customMainColor = _ref.customMainColor;return {
      font: {
        size: '1.6rem',
        lineHeight: '2.4rem',
        weight: 700
      },
      '&:hover': {
        textDecoration: 'none'
      },
      color: customMainColor || colors.neutral[900]
    };},
  bugIcon: {
    marginLeft: '0.3rem'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map